import { __assign, __extends } from "tslib";
import { AutoScalingServiceException as __BaseException } from "./AutoScalingServiceException";
export var AcceleratorManufacturer;
(function (AcceleratorManufacturer) {
    AcceleratorManufacturer["AMAZON_WEB_SERVICES"] = "amazon-web-services";
    AcceleratorManufacturer["AMD"] = "amd";
    AcceleratorManufacturer["NVIDIA"] = "nvidia";
    AcceleratorManufacturer["XILINX"] = "xilinx";
})(AcceleratorManufacturer || (AcceleratorManufacturer = {}));
export var AcceleratorName;
(function (AcceleratorName) {
    AcceleratorName["A100"] = "a100";
    AcceleratorName["K80"] = "k80";
    AcceleratorName["M60"] = "m60";
    AcceleratorName["RADEON_PRO_V520"] = "radeon-pro-v520";
    AcceleratorName["T4"] = "t4";
    AcceleratorName["V100"] = "v100";
    AcceleratorName["VU9P"] = "vu9p";
})(AcceleratorName || (AcceleratorName = {}));
export var AcceleratorType;
(function (AcceleratorType) {
    AcceleratorType["FPGA"] = "fpga";
    AcceleratorType["GPU"] = "gpu";
    AcceleratorType["INFERENCE"] = "inference";
})(AcceleratorType || (AcceleratorType = {}));
var ActiveInstanceRefreshNotFoundFault = (function (_super) {
    __extends(ActiveInstanceRefreshNotFoundFault, _super);
    function ActiveInstanceRefreshNotFoundFault(opts) {
        var _this = _super.call(this, __assign({ name: "ActiveInstanceRefreshNotFoundFault", $fault: "client" }, opts)) || this;
        _this.name = "ActiveInstanceRefreshNotFoundFault";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ActiveInstanceRefreshNotFoundFault.prototype);
        return _this;
    }
    return ActiveInstanceRefreshNotFoundFault;
}(__BaseException));
export { ActiveInstanceRefreshNotFoundFault };
export var ScalingActivityStatusCode;
(function (ScalingActivityStatusCode) {
    ScalingActivityStatusCode["Cancelled"] = "Cancelled";
    ScalingActivityStatusCode["Failed"] = "Failed";
    ScalingActivityStatusCode["InProgress"] = "InProgress";
    ScalingActivityStatusCode["MidLifecycleAction"] = "MidLifecycleAction";
    ScalingActivityStatusCode["PendingSpotBidPlacement"] = "PendingSpotBidPlacement";
    ScalingActivityStatusCode["PreInService"] = "PreInService";
    ScalingActivityStatusCode["Successful"] = "Successful";
    ScalingActivityStatusCode["WaitingForELBConnectionDraining"] = "WaitingForELBConnectionDraining";
    ScalingActivityStatusCode["WaitingForInstanceId"] = "WaitingForInstanceId";
    ScalingActivityStatusCode["WaitingForInstanceWarmup"] = "WaitingForInstanceWarmup";
    ScalingActivityStatusCode["WaitingForSpotInstanceId"] = "WaitingForSpotInstanceId";
    ScalingActivityStatusCode["WaitingForSpotInstanceRequestId"] = "WaitingForSpotInstanceRequestId";
})(ScalingActivityStatusCode || (ScalingActivityStatusCode = {}));
var AlreadyExistsFault = (function (_super) {
    __extends(AlreadyExistsFault, _super);
    function AlreadyExistsFault(opts) {
        var _this = _super.call(this, __assign({ name: "AlreadyExistsFault", $fault: "client" }, opts)) || this;
        _this.name = "AlreadyExistsFault";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, AlreadyExistsFault.prototype);
        return _this;
    }
    return AlreadyExistsFault;
}(__BaseException));
export { AlreadyExistsFault };
var ResourceContentionFault = (function (_super) {
    __extends(ResourceContentionFault, _super);
    function ResourceContentionFault(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceContentionFault", $fault: "server" }, opts)) || this;
        _this.name = "ResourceContentionFault";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, ResourceContentionFault.prototype);
        return _this;
    }
    return ResourceContentionFault;
}(__BaseException));
export { ResourceContentionFault };
var ServiceLinkedRoleFailure = (function (_super) {
    __extends(ServiceLinkedRoleFailure, _super);
    function ServiceLinkedRoleFailure(opts) {
        var _this = _super.call(this, __assign({ name: "ServiceLinkedRoleFailure", $fault: "server" }, opts)) || this;
        _this.name = "ServiceLinkedRoleFailure";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, ServiceLinkedRoleFailure.prototype);
        return _this;
    }
    return ServiceLinkedRoleFailure;
}(__BaseException));
export { ServiceLinkedRoleFailure };
var LimitExceededFault = (function (_super) {
    __extends(LimitExceededFault, _super);
    function LimitExceededFault(opts) {
        var _this = _super.call(this, __assign({ name: "LimitExceededFault", $fault: "client" }, opts)) || this;
        _this.name = "LimitExceededFault";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, LimitExceededFault.prototype);
        return _this;
    }
    return LimitExceededFault;
}(__BaseException));
export { LimitExceededFault };
export var BareMetal;
(function (BareMetal) {
    BareMetal["EXCLUDED"] = "excluded";
    BareMetal["INCLUDED"] = "included";
    BareMetal["REQUIRED"] = "required";
})(BareMetal || (BareMetal = {}));
export var BurstablePerformance;
(function (BurstablePerformance) {
    BurstablePerformance["EXCLUDED"] = "excluded";
    BurstablePerformance["INCLUDED"] = "included";
    BurstablePerformance["REQUIRED"] = "required";
})(BurstablePerformance || (BurstablePerformance = {}));
export var CpuManufacturer;
(function (CpuManufacturer) {
    CpuManufacturer["AMAZON_WEB_SERVICES"] = "amazon-web-services";
    CpuManufacturer["AMD"] = "amd";
    CpuManufacturer["INTEL"] = "intel";
})(CpuManufacturer || (CpuManufacturer = {}));
export var InstanceGeneration;
(function (InstanceGeneration) {
    InstanceGeneration["CURRENT"] = "current";
    InstanceGeneration["PREVIOUS"] = "previous";
})(InstanceGeneration || (InstanceGeneration = {}));
export var LocalStorage;
(function (LocalStorage) {
    LocalStorage["EXCLUDED"] = "excluded";
    LocalStorage["INCLUDED"] = "included";
    LocalStorage["REQUIRED"] = "required";
})(LocalStorage || (LocalStorage = {}));
export var LocalStorageType;
(function (LocalStorageType) {
    LocalStorageType["HDD"] = "hdd";
    LocalStorageType["SSD"] = "ssd";
})(LocalStorageType || (LocalStorageType = {}));
export var InstanceMetadataEndpointState;
(function (InstanceMetadataEndpointState) {
    InstanceMetadataEndpointState["Disabled"] = "disabled";
    InstanceMetadataEndpointState["Enabled"] = "enabled";
})(InstanceMetadataEndpointState || (InstanceMetadataEndpointState = {}));
export var InstanceMetadataHttpTokensState;
(function (InstanceMetadataHttpTokensState) {
    InstanceMetadataHttpTokensState["Optional"] = "optional";
    InstanceMetadataHttpTokensState["Required"] = "required";
})(InstanceMetadataHttpTokensState || (InstanceMetadataHttpTokensState = {}));
var ResourceInUseFault = (function (_super) {
    __extends(ResourceInUseFault, _super);
    function ResourceInUseFault(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceInUseFault", $fault: "client" }, opts)) || this;
        _this.name = "ResourceInUseFault";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceInUseFault.prototype);
        return _this;
    }
    return ResourceInUseFault;
}(__BaseException));
export { ResourceInUseFault };
var ScalingActivityInProgressFault = (function (_super) {
    __extends(ScalingActivityInProgressFault, _super);
    function ScalingActivityInProgressFault(opts) {
        var _this = _super.call(this, __assign({ name: "ScalingActivityInProgressFault", $fault: "client" }, opts)) || this;
        _this.name = "ScalingActivityInProgressFault";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ScalingActivityInProgressFault.prototype);
        return _this;
    }
    return ScalingActivityInProgressFault;
}(__BaseException));
export { ScalingActivityInProgressFault };
export var LifecycleState;
(function (LifecycleState) {
    LifecycleState["DETACHED"] = "Detached";
    LifecycleState["DETACHING"] = "Detaching";
    LifecycleState["ENTERING_STANDBY"] = "EnteringStandby";
    LifecycleState["IN_SERVICE"] = "InService";
    LifecycleState["PENDING"] = "Pending";
    LifecycleState["PENDING_PROCEED"] = "Pending:Proceed";
    LifecycleState["PENDING_WAIT"] = "Pending:Wait";
    LifecycleState["QUARANTINED"] = "Quarantined";
    LifecycleState["STANDBY"] = "Standby";
    LifecycleState["TERMINATED"] = "Terminated";
    LifecycleState["TERMINATING"] = "Terminating";
    LifecycleState["TERMINATING_PROCEED"] = "Terminating:Proceed";
    LifecycleState["TERMINATING_WAIT"] = "Terminating:Wait";
    LifecycleState["WARMED_HIBERNATED"] = "Warmed:Hibernated";
    LifecycleState["WARMED_PENDING"] = "Warmed:Pending";
    LifecycleState["WARMED_PENDING_PROCEED"] = "Warmed:Pending:Proceed";
    LifecycleState["WARMED_PENDING_WAIT"] = "Warmed:Pending:Wait";
    LifecycleState["WARMED_RUNNING"] = "Warmed:Running";
    LifecycleState["WARMED_STOPPED"] = "Warmed:Stopped";
    LifecycleState["WARMED_TERMINATED"] = "Warmed:Terminated";
    LifecycleState["WARMED_TERMINATING"] = "Warmed:Terminating";
    LifecycleState["WARMED_TERMINATING_PROCEED"] = "Warmed:Terminating:Proceed";
    LifecycleState["WARMED_TERMINATING_WAIT"] = "Warmed:Terminating:Wait";
})(LifecycleState || (LifecycleState = {}));
export var WarmPoolState;
(function (WarmPoolState) {
    WarmPoolState["Hibernated"] = "Hibernated";
    WarmPoolState["Running"] = "Running";
    WarmPoolState["Stopped"] = "Stopped";
})(WarmPoolState || (WarmPoolState = {}));
export var WarmPoolStatus;
(function (WarmPoolStatus) {
    WarmPoolStatus["PendingDelete"] = "PendingDelete";
})(WarmPoolStatus || (WarmPoolStatus = {}));
var InvalidNextToken = (function (_super) {
    __extends(InvalidNextToken, _super);
    function InvalidNextToken(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidNextToken", $fault: "client" }, opts)) || this;
        _this.name = "InvalidNextToken";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidNextToken.prototype);
        return _this;
    }
    return InvalidNextToken;
}(__BaseException));
export { InvalidNextToken };
export var InstanceRefreshStatus;
(function (InstanceRefreshStatus) {
    InstanceRefreshStatus["Cancelled"] = "Cancelled";
    InstanceRefreshStatus["Cancelling"] = "Cancelling";
    InstanceRefreshStatus["Failed"] = "Failed";
    InstanceRefreshStatus["InProgress"] = "InProgress";
    InstanceRefreshStatus["Pending"] = "Pending";
    InstanceRefreshStatus["Successful"] = "Successful";
})(InstanceRefreshStatus || (InstanceRefreshStatus = {}));
export var PredictiveScalingMaxCapacityBreachBehavior;
(function (PredictiveScalingMaxCapacityBreachBehavior) {
    PredictiveScalingMaxCapacityBreachBehavior["HonorMaxCapacity"] = "HonorMaxCapacity";
    PredictiveScalingMaxCapacityBreachBehavior["IncreaseMaxCapacity"] = "IncreaseMaxCapacity";
})(PredictiveScalingMaxCapacityBreachBehavior || (PredictiveScalingMaxCapacityBreachBehavior = {}));
export var PredefinedLoadMetricType;
(function (PredefinedLoadMetricType) {
    PredefinedLoadMetricType["ALBTargetGroupRequestCount"] = "ALBTargetGroupRequestCount";
    PredefinedLoadMetricType["ASGTotalCPUUtilization"] = "ASGTotalCPUUtilization";
    PredefinedLoadMetricType["ASGTotalNetworkIn"] = "ASGTotalNetworkIn";
    PredefinedLoadMetricType["ASGTotalNetworkOut"] = "ASGTotalNetworkOut";
})(PredefinedLoadMetricType || (PredefinedLoadMetricType = {}));
export var PredefinedMetricPairType;
(function (PredefinedMetricPairType) {
    PredefinedMetricPairType["ALBRequestCount"] = "ALBRequestCount";
    PredefinedMetricPairType["ASGCPUUtilization"] = "ASGCPUUtilization";
    PredefinedMetricPairType["ASGNetworkIn"] = "ASGNetworkIn";
    PredefinedMetricPairType["ASGNetworkOut"] = "ASGNetworkOut";
})(PredefinedMetricPairType || (PredefinedMetricPairType = {}));
export var PredefinedScalingMetricType;
(function (PredefinedScalingMetricType) {
    PredefinedScalingMetricType["ALBRequestCountPerTarget"] = "ALBRequestCountPerTarget";
    PredefinedScalingMetricType["ASGAverageCPUUtilization"] = "ASGAverageCPUUtilization";
    PredefinedScalingMetricType["ASGAverageNetworkIn"] = "ASGAverageNetworkIn";
    PredefinedScalingMetricType["ASGAverageNetworkOut"] = "ASGAverageNetworkOut";
})(PredefinedScalingMetricType || (PredefinedScalingMetricType = {}));
export var PredictiveScalingMode;
(function (PredictiveScalingMode) {
    PredictiveScalingMode["ForecastAndScale"] = "ForecastAndScale";
    PredictiveScalingMode["ForecastOnly"] = "ForecastOnly";
})(PredictiveScalingMode || (PredictiveScalingMode = {}));
export var MetricStatistic;
(function (MetricStatistic) {
    MetricStatistic["Average"] = "Average";
    MetricStatistic["Maximum"] = "Maximum";
    MetricStatistic["Minimum"] = "Minimum";
    MetricStatistic["SampleCount"] = "SampleCount";
    MetricStatistic["Sum"] = "Sum";
})(MetricStatistic || (MetricStatistic = {}));
export var MetricType;
(function (MetricType) {
    MetricType["ALBRequestCountPerTarget"] = "ALBRequestCountPerTarget";
    MetricType["ASGAverageCPUUtilization"] = "ASGAverageCPUUtilization";
    MetricType["ASGAverageNetworkIn"] = "ASGAverageNetworkIn";
    MetricType["ASGAverageNetworkOut"] = "ASGAverageNetworkOut";
})(MetricType || (MetricType = {}));
var InstanceRefreshInProgressFault = (function (_super) {
    __extends(InstanceRefreshInProgressFault, _super);
    function InstanceRefreshInProgressFault(opts) {
        var _this = _super.call(this, __assign({ name: "InstanceRefreshInProgressFault", $fault: "client" }, opts)) || this;
        _this.name = "InstanceRefreshInProgressFault";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InstanceRefreshInProgressFault.prototype);
        return _this;
    }
    return InstanceRefreshInProgressFault;
}(__BaseException));
export { InstanceRefreshInProgressFault };
export var RefreshStrategy;
(function (RefreshStrategy) {
    RefreshStrategy["Rolling"] = "Rolling";
})(RefreshStrategy || (RefreshStrategy = {}));
export var AcceleratorCountRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AcceleratorTotalMemoryMiBRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ActivityFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ActivitiesTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ActivityTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AdjustmentTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AlarmFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AttachInstancesQueryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AttachLoadBalancersResultTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AttachLoadBalancersTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AttachLoadBalancerTargetGroupsResultTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AttachLoadBalancerTargetGroupsTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FailedScheduledUpdateGroupActionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchDeleteScheduledActionAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchDeleteScheduledActionTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchPutScheduledUpdateGroupActionAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ScheduledUpdateGroupActionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchPutScheduledUpdateGroupActionTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CancelInstanceRefreshAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CancelInstanceRefreshTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CompleteLifecycleActionAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CompleteLifecycleActionTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LaunchTemplateSpecificationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LifecycleHookSpecificationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InstancesDistributionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BaselineEbsBandwidthMbpsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MemoryGiBPerVCpuRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MemoryMiBRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var NetworkInterfaceCountRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TotalLocalStorageGBRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var VCpuCountRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InstanceRequirementsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LaunchTemplateOverridesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LaunchTemplateFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MixedInstancesPolicyFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TagFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateAutoScalingGroupTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EbsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BlockDeviceMappingFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InstanceMonitoringFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InstanceMetadataOptionsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateLaunchConfigurationTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateOrUpdateTagsTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteAutoScalingGroupTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LaunchConfigurationNameTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteLifecycleHookAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteLifecycleHookTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteNotificationConfigurationTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeletePolicyTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteScheduledActionTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteTagsTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteWarmPoolAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteWarmPoolTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeAccountLimitsAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeAdjustmentTypesAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FilterFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AutoScalingGroupNamesTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EnabledMetricFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InstanceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SuspendedProcessFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TagDescriptionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InstanceReusePolicyFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var WarmPoolConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AutoScalingGroupFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AutoScalingGroupsTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AutoScalingInstanceDetailsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AutoScalingInstancesTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeAutoScalingInstancesTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeAutoScalingNotificationTypesAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DesiredConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RefreshPreferencesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InstanceRefreshLivePoolProgressFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InstanceRefreshWarmPoolProgressFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InstanceRefreshProgressDetailsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InstanceRefreshFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeInstanceRefreshesAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeInstanceRefreshesTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LaunchConfigurationNamesTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LaunchConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LaunchConfigurationsTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LifecycleHookFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeLifecycleHooksAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeLifecycleHooksTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeLifecycleHookTypesAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeLoadBalancersRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LoadBalancerStateFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeLoadBalancersResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeLoadBalancerTargetGroupsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LoadBalancerTargetGroupStateFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeLoadBalancerTargetGroupsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricGranularityTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricCollectionTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeMetricCollectionTypesAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var NotificationConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeNotificationConfigurationsAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeNotificationConfigurationsTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribePoliciesTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricDimensionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricStatFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricDataQueryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PredictiveScalingCustomizedCapacityMetricFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PredictiveScalingCustomizedLoadMetricFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PredictiveScalingCustomizedScalingMetricFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PredictiveScalingPredefinedLoadMetricFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PredictiveScalingPredefinedMetricPairFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PredictiveScalingPredefinedScalingMetricFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PredictiveScalingMetricSpecificationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PredictiveScalingConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StepAdjustmentFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CustomizedMetricSpecificationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PredefinedMetricSpecificationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TargetTrackingConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ScalingPolicyFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PoliciesTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeScalingActivitiesTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ProcessTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ProcessesTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeScheduledActionsTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ScheduledUpdateGroupActionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ScheduledActionsTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeTagsTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TagsTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeTerminationPolicyTypesAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeWarmPoolAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeWarmPoolTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetachInstancesAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetachInstancesQueryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetachLoadBalancersResultTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetachLoadBalancersTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetachLoadBalancerTargetGroupsResultTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DetachLoadBalancerTargetGroupsTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DisableMetricsCollectionQueryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EnableMetricsCollectionQueryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EnterStandbyAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EnterStandbyQueryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ExecutePolicyTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ExitStandbyAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ExitStandbyQueryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CapacityForecastFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LoadForecastFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPredictiveScalingForecastAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPredictiveScalingForecastTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutLifecycleHookAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutLifecycleHookTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutNotificationConfigurationTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PolicyARNTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutScalingPolicyTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutScheduledUpdateGroupActionTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutWarmPoolAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutWarmPoolTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RecordLifecycleActionHeartbeatAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RecordLifecycleActionHeartbeatTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ScalingProcessQueryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetDesiredCapacityTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetInstanceHealthQueryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetInstanceProtectionAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetInstanceProtectionQueryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartInstanceRefreshAnswerFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartInstanceRefreshTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TerminateInstanceInAutoScalingGroupTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateAutoScalingGroupTypeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
